import ReactModal from 'react-modal';

import { disableScroll, enableScroll } from '../../../helpers/scroll';

import * as Styled from './Modal.styled';

import { type ModalProps } from './Modal.typed';

import { theme } from '../../../helpers/Theme/Theme';

const DEFAULT_TIMEOUT = 200;

const Modal = (props: ModalProps) => {
  const {
    children,
    fixedHeader,
    fixedFooter,
    top = '50%',
    left = '50%',
    bottom,
    right,
    padding = theme.spacing.M16,
    paddingMedium,
    paddingLarge,
    closeTimeoutMS = DEFAULT_TIMEOUT,
    openTimeoutMS = DEFAULT_TIMEOUT,
    offScreenTransform = 'translateX(-50%) translateY(100%)',
    onScreenTransform = 'translateX(-50%) translateY(-50%)',
    onRequestClose,
    width,
    height,
    isOpen,
    contentLabel,
    modalClassName,
    ...rest
  } = props;

  return (
    <>
      <Styled.GlobalOverlayStyle
        openTimeoutMS={openTimeoutMS}
        modalClassName={modalClassName}
        onScreenTransform={onScreenTransform}
        offScreenTransform={offScreenTransform}
        top={top}
        right={right}
        bottom={bottom}
        left={left}
        width={width}
        height={height}
        closeTimeoutMS={closeTimeoutMS}
        {...rest}
      />
      <ReactModal
        className={{
          base: `base-${modalClassName}`,
          afterOpen: `afterOpen-${modalClassName}`,
          beforeClose: `beforeClose-${modalClassName}`,
        }}
        onAfterOpen={disableScroll}
        onAfterClose={enableScroll}
        onRequestClose={onRequestClose}
        overlayClassName="react-modal-overlay"
        closeTimeoutMS={closeTimeoutMS}
        isOpen={isOpen}
        contentLabel={contentLabel}
      >
        <Styled.ModalContent>
          {fixedHeader}
          <Styled.ModalBody
            padding={padding}
            paddingMedium={paddingMedium}
            paddingLarge={paddingLarge}
          >
            {children}
          </Styled.ModalBody>
          {fixedFooter}
        </Styled.ModalContent>
      </ReactModal>
    </>
  );
};

export { Modal };
